import { render } from "./index.vue?vue&type=template&id=058b282a&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=058b282a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-058b282a"

export default script